import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux"
//UI
import { Table, Segment, Header, Button, Input, Message } from "semantic-ui-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../../../styles/common.css";
import { scrollToTop } from "../../../resources/utils";
import { fetchReservationDueDateThunk, initialStateReservationDueDate } from "../../../../redux/slices/custom/reservations/cruise/reservationDueDate/reservationDueDate.slice";
import { Link } from "react-router-dom";
import { fetchYachts } from "../../../../redux/actions/catalogs/yacht/fetchYachts";

export default function ReservationDueDateList() {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cruiseYacht, setCruiseYacht] = useState(
    localStorage.getItem("yacht") !== null
      ? localStorage.getItem("yacht")
      : "all"
  );
  const { items, fetching, error } = useSelector((state) => state.reservationDueDate);
  const yachtState = useSelector((state) => state.yachtsReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchReservationDueDateThunk(cruiseYacht, startDate, endDate));
    dispatch(fetchYachts());
    scrollToTop();
    return () => {
      dispatch(initialStateReservationDueDate());
    };
  }, []);

  if (fetching || yachtState.fetching) {
    return <CircularProgress />;
  }

  const handleSearchCruiseYacht = () => {
    dispatch(fetchReservationDueDateThunk(cruiseYacht, startDate, endDate));
  };

  return (
    <>
      {error ? (
        <Message negative content={t(error)} />
      ) : (
        ""
      )}
      <Segment className="flex items-center justify-between">
        <div className="ui breadcrumb">
          <div className="active section text-lg">{t("reservationDueDate_tag")} </div>
        </div>
        <Header as='h5' floated='right' className="flex items-center gap-2">
          <div className="flex flex-col">
            <label className="text-gray-500">{t("advance_report_yacht")}</label>
            <select name="yacht_id" className="ui selection dropdown font-normal" aria-expanded="true"
              style={{ padding: '3px 5px' }}
              value={cruiseYacht}
              onChange={(event) => {
                setCruiseYacht(event.target.value);
                localStorage.setItem("yacht", event.target.value);
              }}
            >
              <option value="all">{t("all")}</option>
              {yachtState.yachts.map((yacht) => (
                <option key={yacht.id} value={yacht.id}>{yacht.name}</option>
              ))}
            </select>
          </div>
          <Input type="date" className="flex flex-col">
            <label className="font-semibold text-gray-500">{t("statistic_startDate")}</label>
            <input
              value={startDate}
              onChange={(event) => setStartDate(event.target.value)}
            />

          </Input>
          <Input type="date" className="flex flex-col">
            <label className="font-semibold text-gray-500">{t("statistic_endDate")}</label>
            <input
              value={endDate}
              onChange={(event) => setEndDate(event.target.value)}
            />

          </Input>
          <div className="flex flex-col mt-[17px]">
            <Button
              onClick={handleSearchCruiseYacht}
              type="submit"
              className="ui primary button">
              {t("search_button")}
            </Button>
          </div>
        </Header>
      </Segment>
      <Table color="blue" striped>
        <Table.Header align="left">
          <Table.Row>
            <Table.HeaderCell>{t("reservation_timeLimit")}
              <br></br><span className="text_date_format">(dd-mm-yyyy)</span>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("cruise_title")}
              <br></br><br></br>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("reservation_date")}
              <br></br><span className="text_date_format">(dd-mm-yyyy)</span>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("reservation_agency")}
              <br></br><br></br>
            </Table.HeaderCell>
             <Table.HeaderCell>{t("reservation_notes")}
              <br></br><br></br>
            </Table.HeaderCell>
            <Table.HeaderCell>{t("reservation_executive")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell>{t("reservation_type")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell>{t("reservation_price")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell align="center">{t("reservation_r")}<br></br><br></br></Table.HeaderCell>
            <Table.HeaderCell align="center">{t("cabin_title")}<br></br><br></br></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body align="left">
          {items.map((cruise) => (
            <Table.Row key={cruise.cruise_id} className="text-gray-500">
              <Table.Cell style={{ fontSize: "14px", backgroundColor: '#7ae7bf' }}>
                <b>{cruise.time_limit}</b>
              </Table.Cell>
              <Table.Cell>
                <div className="flex flex-col items-start leading-none ">
                  <p className="text-md font-semibold m-0"> {cruise.yacht_name} {cruise.cruise_code}</p>
                  <p className="text-sm flex items-center gap-2 m-0"><span className=" font-semibold">{t("cruise_startDate")}:</span> {cruise.start_date}</p>
                  <p className="text-sm flex items-center gap-2 m-0"><span className=" font-semibold">{t("cruise_startDate")}:</span> {cruise.end_date}</p>
                  <p className="text-sm flex items-center gap-2 m-0"><span className=" font-semibold">{t("cruise_itinerary")}:</span> {cruise.itinerary_name}</p>
                </div>

              </Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.creation_date}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.agency_name}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.notes}</Table.Cell>
              <Table.Cell>{cruise.user}</Table.Cell>
              <Table.Cell>{cruise.cruise_type}</Table.Cell>
              <Table.Cell className="font-semibold">$ {cruise.total_reserved_price}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>{cruise.reserved_spaces}</Table.Cell>
              <Table.Cell style={{ fontSize: "11px" }}>
                {JSON.parse(cruise.cabins).map((booking, index) => (
                  <Link
                    className="font-semibold"
                    key={index}
                    to={`/cruises/${cruise.cruise_id}/reservations/${cruise.reservation_id}/bookings/${booking.booking_id}/spaces`}
                  >
                    {' '}{booking.cabin_name}
                  </Link>
                ))}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
